import {createSlice} from "@reduxjs/toolkit";

export type ModalState = {
    loading: boolean
    notificationModal: boolean
}

const initialState: ModalState = {
    loading: false,
    notificationModal: false
}

const action = {}

const slice = createSlice({
    name: "modal",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload
        },
        setNotificationModal(state, {payload}) {
            state.notificationModal = payload
        },
        reset: () => ({...initialState})

    },

    extraReducers: builder => {
    }
})

export const modal = {
    reducer: slice.reducer,
    action,
    mutation: slice.actions
}